//Navbar.js
///////////////////////////////
//React & Material
import React,{useState} from 'react';
import { motion } from "framer-motion"
//Plugins
import styled from 'styled-components';

//Component Imports
import Container from 'react-bootstrap/Container';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { useHistory, Link,NavLink } from "react-router-dom";
//////////////////////////////
//Styled components
const Wrapper = styled(Container)`
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  margin-top:40px;
  @media only screen and (max-width: 767px) {
    padding-left:30px;
    padding-right:30px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    padding-left:30px;
    padding-right:30px;
  }
`

const Logo = styled.h5`
color: rgba(255, 255, 255, 0.35);
text-align:left;
-webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
&:hover{
    color:white;
  }
  font-weight:bold;
`
const RightSpacer = styled.div`
flex-grow:1;
`
const NavRight = styled.div`
display:flex;
  flex-direction:row;
  align-items:flex-start
`
const SubText = styled.h5`
  margin-right:20px;
  -webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
&:hover{
  color:#36FFC1;
}
`

const CustomLink = styled(Link)`
text-decoration: none;
color: inherit;
text-decoration: inherit;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
    
`
const NLink = styled(NavLink)`
text-decoration: none;
color: inherit;
text-decoration: inherit;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
    
`
const DownLink = styled(AnchorLink)`
text-decoration: none;
color: inherit;
text-decoration: inherit;
-webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:black;
    }
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function Navbar(props) {
  let history = useHistory();

  const [name, setName] = useState("GG")
  

  return (
    
  <Wrapper>
   
    <CustomLink onClick={() => history.push('/blogs')}>
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
      duration: 2,
      ease: "easeIn"
  }}>
      <Logo onMouseEnter={()=>setName("Gayuru Gunawardena")} onMouseLeave={()=>setName("GG")}>
        {name}
      </Logo>
      </motion.div>
    </CustomLink>
    <RightSpacer/>
    <NavRight>
      <DownLink href='#about'>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
      duration: 1,
      ease: "easeIn",
      delay:'2'
  }}>
        <SubText>
          about
        </SubText>
        </motion.div>
      </DownLink>
        <NLink   activeStyle={{ color: '#36FFC1'}} to={'/blogs'}>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
      duration: 1,
      ease: "easeIn",
      delay:'3'
  }}>
        <SubText>
          blog
        </SubText>
        </motion.div>
        </NLink>
    </NavRight>
    
  </Wrapper>
  )
}
export default Navbar;